// ─────────────────────────────────────────────────────────────────────────────
// Calculs de la grille salariale — fonctions pures, sans Firestore (testables).
//
// La grille master (pulse_salary_grid) stocke les taux horaires 2026 réels par
// classe + échelon, et l'augmentation annuelle de la grille (aug_grille_pct) par
// classe. L'équivalent annuel = taux × heures de base. La projection vers les
// années futures applique aug_grille_pct.
// ─────────────────────────────────────────────────────────────────────────────

export type HoursParams = {
  base_hours_per_week: number
  weeks_per_year: number
}

// Arrondi à 2 décimales, demi-vers-le-haut (équivalent au formatage Excel).
export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

// Nombre total d'heures payées dans une année (40 × 52 = 2080 par défaut).
export function annualHours(params: HoursParams): number {
  return params.base_hours_per_week * params.weeks_per_year
}

// Équivalent annuel d'un taux horaire, arrondi au dollar.
export function annualFromHourly(hourly: number, params: HoursParams): number {
  return Math.round(hourly * annualHours(params))
}

// Projette un taux 2026 vers une année cible via l'augmentation annuelle de la
// grille de la classe. `yearOffset` = nombre d'années après 2026. Non arrondi
// (l'appelant arrondit à l'affichage). aug_grille_pct null ⇒ taux constant.
export function projectYearRate(
  rate2026: number,
  yearOffset: number,
  augGrillePct: number | null,
): number {
  if (!augGrillePct || yearOffset <= 0) return rate2026
  return rate2026 * Math.pow(1 + augGrillePct, yearOffset)
}
